<template>
	<div class="certifiy-accomplish">
		<ul class="adv-and-r-ul" v-if="certifyInfo.certifyType === '2'">
			<li>
				<i class="adv-and-r-ul-title"><i class="el-icon-success"></i> 已完成站神个人实名认证！</i>
			</li>
			<li>
				<label for>真实姓名：</label>
				<span>{{perName}}</span>
			</li>
			<li>
				<label for>证件号码：</label>
				<span>{{perIdNum}}</span>
			</li>

			<li>
				<a href="javascript:;" class="organize_renzheng" @click="goToEntCertify">升级企业认证</a>
			</li>
		</ul>
		<ul class="adv-and-r-ul" v-else>
			<li>
				<i class="adv-and-r-ul-title"><i class="el-icon-success"></i> 已完成站神企业实名认证！</i>
			</li>
			<li>
				<label for>企业名称：</label>
				<span>{{entName}}</span>
			</li>
			<li>
				<label for>营业执照注册号：</label>
				<span>{{entRegNum}}</span>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'ADVPAndR',
	props: ['certifyInfo'],
	computed: {
		entName () {
			let entName = this.certifyInfo.entName
			return this.regReplaceMid(entName)
		},
		entRegNum () {
			let entRegNum = this.certifyInfo.entRegNum
			return this.regReplaceMid(entRegNum)
		},
		perName () {
			let perName = this.certifyInfo.perName
			return this.regReplaceHead(perName)
		},
		perIdNum () {
			let perIdNum = this.certifyInfo.perIdNum
			return this.regReplaceMid(perIdNum)
		}
	},
	methods: {
		goToEntCertify () {
			this.$parent.cur = 'acform'
			this.$router.push({
				name: 'certify',
				query: {
					cur: '1'
				}
			})
		},
		regReplaceHead (perName) {
			return perName.replace(/(.+)?(.{1})/, function (match, $1, $2) {
				let res = ''
				for (let i = 0;i < $1.length;i++) {
					res += '*'
				}
				return res + $2
			})
		},
		regReplaceMid (name) {
			return name.replace(/^(.{3})(.+)(.{3})$/, function (match, $1, $2, $3, $4) {
				let res = ''
				for (let i = 0;i < $2.length;i++) {
					res += '*'
				}
				return $1 + res + $3
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.certifiy-accomplish{
	padding: 49px 0 92px 77px;
}
.adv-and-r-ul {
	li {
		&:first-child{
			margin-bottom:22px ;
		}
		height: 30px;
		line-height: 30px;
		.adv-and-r-ul-title {
			font-style: normal;
			font-size: 20px;
			color: $colorD;
			text-align: left;
			i{
				font-size: 23px;
				line-height: 26px;
				vertical-align: initial;
			}
		}
		a.organize_renzheng {
			margin-top:20px;
			display: inline-block;
			width: 150px;
			height: 30px;
			color: #fff;
			background: $colorA;
			font-size: 12px;
			text-align: center;
			line-height: 30px;
			border-radius: 2px;
		}
	}
}
</style>
